module.exports = __webpack_public_path__ + "img/message_off.06a8dab8.svg";